module.exports = __webpack_public_path__ + "static/interior_off_left-1ddae0e6975900e591bf6f46e0f9a86b.png";